import React from 'react';

const NotFound: React.FunctionComponent<React.PropsWithChildren<unknown>> = () => <h1> NOT FOUND </h1>;

export default NotFound;
